<div class="m-slide-transition"
     :class="{'m--is-left-to-right-transition': isLeftToRight}">
    <transition :name="transitionName"
                :css="!disabled"
                @before-enter="beforeEnter"
                @enter="enter"
                @after-enter="afterEnter"
                @enter-cancelled="enterCancelled"
                @before-leave="beforeLeave"
                @leave="leave"
                @after-leave="afterLeave"
                @leave-cancelled="leaveCancelled">
        <slot></slot>
    </transition>
</div>
